import { openDB, DBSchema } from 'idb'

interface SavedRequestDb extends DBSchema {
  requests: {
    key: string,
    value: {
      url: string
      headers: string
      body: string
    }
  }
}

async function saveFailedRequest(reqs: Request[]) {
  const requests = reqs.splice(0, reqs.length);
  try {
    const db = await openDB<SavedRequestDb>('railytics-requests', undefined, {
      upgrade: (db) => {
        if(!db.objectStoreNames.contains('requests')) {
          db.createObjectStore('requests', { keyPath: 'url' })
        }
      },
      terminated: () => {
        console.error('La connessione al db si è chiusa in modo anomalo')
      }
    })
    const reqsPromises = requests.map(async req => {
      const request = req.clone()
      const { url, headers } = request
      const body = await request.text()
      return db.put('requests', {
        url,
        headers: JSON.stringify(Object.fromEntries(headers.entries())),
        body
      }, url)
    })
    await Promise.allSettled(reqsPromises)
    db.close()
  } catch (e) {
    console.error('Errore nel salvataggio della request', e)
  }
}

const failedRequestsQueue = new Proxy([] as Request[], {
  set: (target, prop, value, receiver) => {
    const setted = Reflect.set(target, prop, value, receiver)
    if (target.length >= 10) {
      void saveFailedRequest(target)
    }
    return setted
  }
})

class FailedRequestManager {
  private constructor() {/* empty */}

  private static _instance: FailedRequestManager
  public static get instance() {
    if (FailedRequestManager._instance === undefined) {
      FailedRequestManager._instance = new FailedRequestManager()
    }
    return FailedRequestManager._instance
  }

  public set(req: Request) {
    failedRequestsQueue.push(req)
  }

  public async flush() {
    if (failedRequestsQueue.length) {
      await saveFailedRequest(failedRequestsQueue)
    }
  }
}

export const failedRequestManager = FailedRequestManager.instance;
